export const Paths = {
  notFound: "*",
  login: "/",
  sell: "/sell",
  exchange: "/exchange",
  purchase: "/purchase",
  deposit: "/deposit",
  return: "/return",
};
